export interface InnerLayoutProps {
  children: React.ReactNode
}

export const useInnerLayout = (props: InnerLayoutProps) => {
  return {
    ...props,
  }
}
